class UTMTracker {
    private utmParams: { [key: string]: string } = {};
    private currentTimestamp: number = new Date().getTime();
    private lastTimestamp: number = 0;
    private eightHoursInMilliseconds: number = 8 * 60 * 60 * 1000;

    constructor() {
        this.lastTimestamp = parseInt(this.getCookie('UTMTracker_LastTimestamp') || '0', 10);
        this.parseUTMParams();
        this.updateTimestamp();
        this.handleSession();
        this.handleFirstVisit();
		this.handleLastUTMParams();
    }

    private parseUTMParams(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const utmKeys = ['utm_term', 'utm_content', 'utm_campaign', 'utm_medium', 'utm_source'];

        utmKeys.forEach((key) => {
            const value = urlParams.get(key);
            if (value) {
                this.utmParams[key] = value;
            }
        });
    }

    private updateTimestamp(): void {
        this.setCookie('UTMTracker_LastTimestamp', this.currentTimestamp.toString(), 365);
    }

    private handleSession(): void {
        const isNewSession =
            this.currentTimestamp - this.lastTimestamp > this.eightHoursInMilliseconds ||
            Object.keys(this.utmParams).length > 0;

        if (isNewSession) {
            // Directly placing the code that was previously in storeSessionData
            this.storeData('Session', 1);
        }
    }

    private handleFirstVisit(): void {
        if (!this.getCookie('First_user_source__c')) {
            this.storeData('First_user', 365);
        }
    }

    private handleLastUTMParams(): void {
        if (Object.keys(this.utmParams).length > 0) {
            this.storeData('Last_UTM', 365);
        }
    }

    private storeData(prefix: string, days: number): void {
        const keys = ['term', 'content', 'campaign', 'medium', 'source'];

        keys.forEach((key) => {
            const utmKey = `utm_${key}`;
            const cookieName = `${prefix}_${key}__c`;
            const value = this.utmParams[utmKey] || 'UNKNOWN';
            this.setCookie(cookieName, value, days);
        });
    }

    private getCookie(name: string): string | null {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let c of ca) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

    private setCookie(name: string, value: string, days: number): void {
        const date = new Date();
        date.setTime(date.getTime() + days * 86400000); // 86400000 ms in a day
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }
}

// Initialize the UTM tracking
if (document.readyState === 'complete') {
    // If the load event has already happened
    new UTMTracker();
} else {
    // Wait for the load event if it hasn't happened yet
    window.addEventListener('load', () => {
        new UTMTracker();
    });
}
